import React, {
  createContext,
  FC,
  useContext,
  useEffect,
  useState,
} from 'react';
import { Locale } from 'date-fns';
import { getDateLocale } from 'utils/data/language/getDateLocale';
import { enUS } from 'date-fns/locale/en-US';

const DateLocaleContext = createContext<Locale>(enUS);

export const useGlobalDateLocale = () => {
  const localeContext = useContext(DateLocaleContext);
  if (!localeContext) {
    throw new Error(
      'useGlobalDateLocale must be used inside <DateLocaleProvider>',
    );
  }
  return localeContext;
};

interface DateLocaleProviderProps {
  children: React.ReactNode;
  langCode: string;
}

export const DateLocaleProvider: FC<DateLocaleProviderProps> = ({
  children,
  langCode,
}) => {
  const [locale, setLocale] = useState<Locale>(enUS);

  useEffect(() => {
    getDateLocale(langCode).then(setLocale);
  }, [langCode]);

  return (
    <DateLocaleContext.Provider value={locale}>
      {children}
    </DateLocaleContext.Provider>
  );
};

export default DateLocaleContext;
